import { z } from 'zod'

export const vtoSearchSchema = z.object({
  view: z.enum(['grid', 'list']).optional().catch('grid'),
  folder: z.string().optional().catch(undefined),
  q: z.string().optional(),
  authorId: z.string().optional(),
  talent: z.string().optional(),
  /** Opens the create drawer; with `talent`, that talent is picked. */
  create: z.boolean().optional().catch(undefined),
  approval: z.enum(['approved', 'denied', 'pending']).optional(),
  collection: z.string().optional(),
  gender: z.string().optional(),
  mainGroup: z.string().optional(),
  subGroup: z.string().optional(),
  category: z.string().optional(),
  tags: z.array(z.uuid()).optional().catch(undefined),
})

export type VTOSearchParams = z.infer<typeof vtoSearchSchema>
